import { useAlert } from 'context/alert';
import React from 'react';
import { Log } from 'utils/helpers';

interface UseAlert {
  alerts: unknown;
  handleDismissAlert: unknown;
  throwAlert: (opts: { id: string; message: string; type: string }) => void;
}

export function useError() {
  const { throwAlert } = useAlert() as unknown as UseAlert;

  const reportError = React.useCallback(
    (id: string, error: unknown) => {
      let message;
      if (typeof error === 'string') {
        message = error;
      } else if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
        message = error.message;
      }
      if (message) {
        throwAlert({
          id: `${id?.replace(/ /g, '-')}`,
          message: message,
          type: 'error',
        });
      }
      Log.error(id, error);
    },
    [throwAlert]
  );

  return { reportError };
}
